import { update } from "./API";

export const UpdatePlatforms = async (platform_id: number, payload: any) => {
  try {
    return await update(
      `${process.env.REACT_APP_API_URL}/platforms/${platform_id}`,
      payload
    );
  } catch (err: any) {
    if (err.request) return err.request;
    if (err.response) return err.response;
    return err.message;
  }
};
